import html2canvas from 'html2canvas';

export default (context, inject) => {
  inject('html2canvas', html2canvas)
}
